<template>
  <div class="sdg-block d-flex flex-row w-100 mb-4">
    <div class="d-flex flex-column w-100">
      <div class="sdg-title">{{ title }}</div>
      <div class="sdg-text" v-dompurify-html="text"></div>
    </div>
    <div class="sdg-icon">
      <img :src="icon" />
    </div>
  </div>
</template>

<script>
export default {
  name: "SdgPanel",
  props: {
    title: String,
    subTitle: String,
    icon: String,
    text: String
  }
};
</script>

<style scoped></style>
